import React from 'react';
import { createEditorPluginAIConfigItemMarkdown } from '../../../config-items/config-items';
import { generate } from '../../../provider/prompt-requests/generate';
import { summaryConvoAI } from '../../../provider/prompt-requests/summary';
import { createInsertAtCurrentPosition, createInsertAtTop } from '../../config-item-actions/markdown';
import { sliceOrNodeToMarkdown } from '../../../config-items/slice-or-node-to-markdown';
import { messages } from './messages';
import { Icon } from '../../assets/icons/findActionItems';
import { isMinLength } from '../../config-item-visible/visibility-utils';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { getBackendModelExperiment } from '../../utils';
const SELECTION_TYPE = 'empty';
export const findActionItemsConfigItem = createEditorPluginAIConfigItemMarkdown({
  title: ({
    formatMessage
  }) => formatMessage(messages.title),
  description: ({
    formatMessage
  }) => formatMessage(messages.description),
  selectionType: SELECTION_TYPE,
  getInitialContext: ({
    editorView,
    intl,
    updateIdMap
  }) => {
    const {
      markdown,
      contentStatistics
    } = sliceOrNodeToMarkdown({
      node: editorView.state.doc,
      intl,
      editorView,
      convertTo: 'markdown-plus',
      updateIdMap,
      selectionType: SELECTION_TYPE
    });
    return {
      document: markdown,
      userLocale: intl.locale,
      intentSchemaId: 'action_items_intent_schema.json',
      contentStatistics
    };
  },
  icon: ({
    shownAt
  }) => /*#__PURE__*/React.createElement(Icon, {
    shownAt: shownAt
  }),
  triggerPromptRequest({
    initialContext,
    editorSchema,
    backendModel
  }) {
    if (getBooleanFF('platform.editor.ai-assistance-service-find-action-items')) {
      return summaryConvoAI({
        userLocale: initialContext.userLocale,
        intentSchemaId: 'action_items_intent_schema.json',
        editorSchema,
        fullDocument: initialContext.document,
        backendModel
      });
    }
    return generate({
      userLocale: initialContext.userLocale,
      editorSchema,
      intentSchemaId: initialContext.intentSchemaId,
      contextList: [{
        type: 'ADF_MARKDOWN_V1',
        entity: initialContext.document,
        relationship: 'FULL_CONTENT'
      }]
    });
  },
  isVisible: ({
    editorView
  }) => isMinLength({
    editorView,
    minLength: 1
  }),
  actions: [createInsertAtTop({
    appearance: 'secondary'
  }), createInsertAtCurrentPosition({
    appearance: 'primary'
  })],
  getBackendModel: () => {
    if (getBooleanFF('platform.editor.ai-assistance-service-find-action-items')) {
      return 'assistance-service';
    }
    return getBackendModelExperiment();
  }
});